import { createFileRoute, redirect } from "@tanstack/react-router";
import { LeadsTableEnhanced } from "@/app/partner/pages/leads/LeadsTableEnhanced";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/leads/")({
	validateSearch: (search: Record<string, unknown>): { action?: string } => ({
		action: typeof search.action === "string" ? search.action : undefined,
	}),
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "leads");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: LeadsTableEnhanced,
});
